import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "./3B.component.html",
  styleUrls: ["../component.css"]
})
export class _3BComponent extends ModuleComponent {

  B22: string = ` `;
  B23: string = ` `;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "B11",
      "html": `<i class="fas fa-file-import"></i> Start a Savings or Checking Account.`
    });
    this.titles.push({
      "activityId": "B12",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Use the Money Management Guide to help you reach your financial goals."`
    });

    this.titles.push({
      "activityId": "B21",
      "html": `<i class="fas fa-file-import"></i> Determine your current financial status and set goals to create monitor and adjust your budget.`
    });
    this.titles.push({
      "activityId": "B22",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Identify financial goals​</strong>`
    });
    this.titles.push({
      "activityId": "B23",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Identify</strong> your emergency savings, debt, and saving for future purchases.`
    });
    this.titles.push({
      "activityId": "B24",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Getting and staying out of debt."`
    });

    this.titles.push({
      "activityId": "B31",
      "html": `<i class="fas fa-file-import"></i> <strong>Test</strong> your knowledge of what you learned. These questions will be on the post-assessment test.`
    });


    this.group = 2;
    this.alpha = "B";

    this.activeMod = { group: 2, alpha: "B", number: 1 };
  }

  ngOnInit() {    
  }

  ngAfterViewInit() {

    this.loadGuide();
  }
}
